import { Identifiable, Resource } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  resource: Identifiable<Resource>,
  { resources }: Filter,
): boolean {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find(({ uuid }) => uuid === resource.uuid)
  );
}

export { isFilteredByResources };
